// ScienceAwards.js
import { Cards } from './Cards.js';
import './css/mycss.css';

import img1 from './images/sc1.png';
import img2 from './images/sc2.png';
import img3 from './images/sc3.png';
import img4 from './images/sc4.png';
import img5 from './images/sc5.png';
import img6 from './images/sc6.png';
import img7 from './images/sc7.png';


/* ----------------- EXPORT DATA FOR SEARCH ----------------- */

export const scienceAwardsData = [
  {
    category: "Science",
    htext: "Vigyan Ratna Award",
    ptext: "India’s highest honour for lifetime contributions in science & technology.",
    img1,
    ialt: "Vigyan Ratna Award",
    modalContent: `
      <b>Established:</b> 2023<br/>
      <b>Type:</b> India’s top lifetime achievement award in science and technology<br/>
      <b>First Awarded:</b> 2024<br/>
      <b>First Recipient:</b> Govindarajan Padmanabhan<br/>
      <b>Material:</b> Gold-toned medal (symbolic representation – actual design varies)<br/>
      <b>Symbolism:</b> Recognises scientists with decades of contribution driving India's scientific progress.<br/>
      <b>Awarded For:</b> Outstanding lifetime contribution in scientific research, technology advancement & national growth.<br/><br/>
      <a href='https://en.wikipedia.org/wiki/Vigyan_Ratna_Award'>Wiki link</a>
    `
  },
  {
    category: "Science",
    htext: "Vigyan Shri Award",
    ptext: "Recognises major scientific contribution at senior & mid-career level.",
    img1: img2,
    ialt: "Vigyan Shri Award",
    modalContent: `
      <b>Established:</b> 2023<br/>
      <b>Type:</b> Senior/Mid-career national science honour<br/>
      <b>First Awarded:</b> 2024<br/>
      <b>First Recipient:</b> Annapurni Subramaniam<br/>
      <b>Symbolism:</b> Encourages excellence in laboratories & research advancement.<br/>
      <b>Awarded For:</b> Progressive contribution to research, innovation & technology. <br/><br/>
      <a href='https://en.wikipedia.org/wiki/Vigyan_Shri_Award'>Wiki link</a>
    `
  },
  {
    category: "Science",
    htext: "Vigyan Yuva-Shanti Swarup Bhatnagar Award",
    ptext: "Award for exceptional young scientists under the age of 45.",
    img1: img3,
    ialt: "Vigyan Yuva-SS Bhatnagar Award",
    modalContent: `
      <b>Established:</b> 2023<br/>
      <b>Type:</b> Young Scientist Recognition<br/>
      <b>Age Limit:</b> Below 45 years<br/>
      <b>Symbolism:</b> Motivates India's brightest youth researchers.<br/>
      <b>Awarded For:</b> Path-breaking contributions in S&T research domains.<br/><br/>
      <a href='https://en.wikipedia.org/wiki/Vigyan_Yuva-Shanti_Swarup_Bhatnagar_Award'>Wiki link</a>
    `
  },
  {
    category: "Science",
    htext: "Vigyan Team Award",
    ptext: "Honours collaborative scientific breakthroughs such as missions & large research teams.",
    img1: img4,
    ialt: "Vigyan Team Award",
    modalContent: `
      <b>First Recipient:</b> ISRO Chandrayaan-3 Team<br/>
      <b>Type:</b> National Team Science Honour<br/>
      <b>Purpose:</b> Recognises collaborative contributions that impact science nationally.<br/>
      <b>Symbolism:</b> Represents teamwork-driven innovation & mission success.<br/>
      <b>Awarded For:</b> Major science missions, collective research breakthroughs.<br/><br/>
      <a href='https://en.wikipedia.org/wiki/Vigyan_Team_Award'>Wiki link</a>
    `
  },
  {
    category: "Science",
    htext: "Shanti Swarup Bhatnagar Prize",
    ptext: "India’s most prestigious research award for scientists under 45.",
    img1: img5,
    ialt: "Shanti Swarup Bhatnagar Prize",
    modalContent: `
      <b>Established:</b> 1958<br/>
      <b>Type:</b> National Research Excellence Award<br/>
      <b>Awarded By:</b> Council of Scientific & Industrial Research (CSIR)<br/>
      <b>Age Limit:</b> Under 45 years<br/>
      <b>Given For:</b> Mathematics, Engineering, Medical Science, Physics, Chemistry, Earth Sciences & Biology.<br/>
      <b>Significance:</b> Most respected science prize for young researchers in India.<br/><br/>
      <a href='https://en.wikipedia.org/wiki/Shanti_Swarup_Bhatnagar_Prize_for_Science_and_Technology'>Wiki link</a>
    `
  },
  {
    category: "Science",
    htext: "India Science Award",
    ptext: "National honour for outstanding work in science research & innovation.",
    img1: img6,
    ialt: "India Science Award",
    modalContent: `
      <b>Established:</b>2003</br>
       <b>Type:</b>National award, presented by Indian Science Congress Association in association with Ministry of Science & Technology.<br/> 
       <b>First Awarded:</b>2004</br> 
       <b>First Recipient: </b>C. N. R. Rao, chemist</br> 
       <b> Symbolism:</b>The gold medal and significant cash prize symbolise the highest level of national appreciation for scientific excellence, across varied fields — meant to encourage broad, impactful research.</br> <b> 
       Awarded For:</b>Outstanding, widely recognised excellence in scientific research (across science, engineering, medicine, agriculture etc.), with broad impact.</br> <br/>
       <b><a href='https://en.wikipedia.org/wiki/India_Science_Award'>wiki link</a></b>
    `
  },
  {
    category: "Science",
    htext: "Infosys Prize",
    ptext: "Award recognising groundbreaking academic research across fields.",
    img1: img7,
    ialt: "Infosys Prize",
    modalContent: `
      <b>Established:</b> 2008<br/>
      <b>Type:</b> Independent Foundation Award<br/>
      <b>Fields:</b> Engineering, Humanities, Social Sciences, Mathematics, Medicine, Biological Sciences<br/>
      <b>Prize:</b> Gold Medal + Large Cash Grant<br/>
      <b>Significance:</b> Among India’s highest research grant awards.<br/><br/>
      <a href='https://en.wikipedia.org/wiki/Infosys_Prize'>Wiki link</a>
    `
  }
];


/* ----------------- COMPONENT VIEW (UI PAGE) ----------------- */

export default function ScienceAwards() {
  return (
    <div>
      <h1 className="heading">Science Awards</h1>
      <h3 className="head2">“Honouring innovation, discovery and scientific progress.”</h3>

      <div className="search-cards-container">
        {scienceAwardsData.map((award, i) => (
          <Cards
            key={i}
            htext={award.htext}
            ptext={award.ptext}
            img1={award.img1}
            ialt={award.ialt}
            btext="Learn more"
            modalContent={award.modalContent}
          />
        ))}
      </div>
    </div>
  );
}
